import React, { ReactNode } from 'react'


interface IProps { 
    children: ReactNode
}

const GridDataCellWrapper: React.FC<IProps> = ({ children, ...props }) => {

    return(
        <div className="grid-data-cell-wrapper">
            {children}
        </div>
    )
}

export default GridDataCellWrapper;